import { Box, Icon } from '@factorialco/deprecated-design-system'

import Portal from 'modules/core/components/Portal'

import styles from './index.module.scss'

type Props = {
  videoId: string
  onClose: () => void
}

const FirstStepsVideo = ({ videoId, onClose }: Props) => {
  return (
    <Portal locked onClose={onClose}>
      <Box className={styles.firstStepVideoOverlay} background="darker400" onClick={onClose}>
        <Box gap="s8" className={styles.firstStepVideoModal}>
          <button onClick={onClose}>
            <Icon.Medium icon="cross" color="grey000White" />
          </button>
          <Box className={styles.wistiaVideo}>
            <iframe
              src={`https://fast.wistia.net/embed/iframe/${videoId}?videoFoam=true&autoPlay=true `}
              allowFullScreen
            />
          </Box>
        </Box>
      </Box>
    </Portal>
  )
}

export default FirstStepsVideo
